<button
  class="print-btn"
  [printStyle]="{ div: { '-webkit-print-color-adjust': 'exact' } }"
  printSectionId="print-section"
  styleSheetFile="assets/defect-styles.css"
  ngxPrint
>
  print
</button>

<div id="print-section">
  <div class="defect-list-wrapper">
    <div class="title">Garment Images</div>

    <table class="header-row">
      <tr>
        <th>Date</th>
        <th>Buyer</th>
        <th>Style</th>
        <th>PO</th>
        <th>ERP Key</th>
        <th>Color</th>
      </tr>
      <tr>
        <td>{{ defectList.sessionDate }}</td>
        <td>{{ defectList.buyer }}</td>
        <td>{{ defectList.style }}</td>
        <td>{{ defectList.po }}</td>
        <td>{{ defectList.erp_key }}</td>
        <td>{{ defectList.color }}</td>
      </tr>
    </table>

    <div class="defects-wrapper" *ngFor="let operationIssue of defectList.defective_info; let i = index">
      <div
        *ngFor="let operationIssue of defectList.defective_info[i].operations_issues"
        class="operation-issue-wrapper"
      >
        <span class="description-title">Operation: </span> {{ operationIssue.operation }}
        <span class="description"> <span class="description-title">issues: </span> {{ operationIssue.issues }}</span>
      </div>

      <div class="img-table">
        <ng-container *ngFor="let imgSrc of defectList.defective_info[i].image_urls">
          <div><img [src]="imgSrc" /></div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
